function sortObjectByCustomOrder(obj, customOrder) {
  const sortedObj = {};

  customOrder.forEach((key) => {
    if (obj.hasOwnProperty(key)) {
      sortedObj[key] = obj[key];
    }
  });

  Object.keys(obj).forEach((key) => {
    if (!sortedObj.hasOwnProperty(key)) {
      sortedObj[key] = obj[key];
    }
  });

  return sortedObj;
}

function formatPrice(key, value) {
  const amount = parseFloat(value.amount);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: value.currency_code,
  }).format(amount);
}

function loadSpecifications() {
  const list = $('.product-single__tags ul');
  const variant_curr = window.variant_data.filter((item) => item.variant_id === parseInt(inputVariant.value));
  variant_curr.map((item) => {
    let elemen_list_content = document.querySelectorAll('.product-single__tags ul li');
    for (elem_attr of elemen_list_content) {
      elem_attr.remove();
    }

    const valueEditor = `{{ section.settings.order_specifications }}`;
    const valueArray = valueEditor.split(/\s+/);

    const sortedData = sortObjectByCustomOrder(item.specs, valueArray);
    if (Object.values(sortedData).length === 0) {
      $('.product-tags').css('display', 'none');
    } else {
      $('.product-tags').css('display', 'block');
    }

    for (const [key, value] of Object.entries(sortedData)) {
      const excludeSpecs = `{{ section.settings.exclude_specifications }}`;
      const excludeArray = excludeSpecs
        .split(',')
        .map((item) => item.trim().toLowerCase().replace(/\s+/g, '_'))
        .filter((item) => item !== '');

      const formattedKey = key.toLowerCase();
      let displayValue = value;

      if (key === 'price' && value.amount >= 9000000) {
        continue;
      }

      if (key === 'price' && typeof value === 'object' && value.amount && value.currency_code) {
        displayValue = formatPrice(key, value);
      }

      if (!excludeArray.includes(formattedKey)) {
        const html = `
            <li>
              <strong>${key.replace(/_/g, ' ')}</strong>
              <p>${displayValue}</p>
            </li>
            `;
        list.append(html);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  loadSpecifications();
});

const inputVariant = document.querySelector("form[action*='/cart/add'] input[name='id']");
if (inputVariant) {
  inputVariant.addEventListener('change', () => {
    loadSpecifications();
  });
} 

// document.addEventListener('shopify:block:select', function (event) {
//   loadSpecifications();
// });
// document.addEventListener('shopify:section:load', () => {
//   loadSpecifications();
// });
// document.addEventListener('shopify:section:unload', (event) => {
//   loadSpecifications();
// });
